import g from '#core/global';
import load from '#core/load';
// import layout from '#core/layout';


const state = window.teal_state = window.teal_state || {};
state.audio = state.video || {};

const $all_audio_players = [];
const audio_player_$ = '.audio__player';
const audio_element_$ = '.media-figure__source';
const audio_toggle_$ = '.button--transport--audio';
const audio_progress_$ = '.audio__progress-bar';
const is_playing_attr = 'data-is-playing';
const play_status_attr = 'data-play-status';

let has_audio = false;
let progress_interval = null;


const module = {
	is_playing_c: '-play',
	
	
	/**
	 * Init audio players
	 */
	init() {
		if (load.ran('audio')) return false;
		
		load.content(() => {
			has_audio = assign_elements();
			if (!has_audio) return false;
		});
		load.all(() => {
			has_audio = assign_elements();
			if (!has_audio) return false;
		});
	},
	
};

export default module;
module.init();



/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_audio) return true;
	
	// TODO: do not store objects on load, account for dynamic content
	const $audio_players = document.querySelectorAll(audio_player_$);
	if (!$audio_players.length) return false;
	
	$audio_players.forEach(($player, index) => {
		const $audio = $player.querySelector(audio_element_$);
		const $play_button = $player.querySelector(audio_toggle_$);
		const $progress_indicator = $player.querySelector(audio_progress_$);
		
		$audio.addEventListener(g.ended_e, () => {
			reset_player(index);
		});
		$play_button.addEventListener(g.click_e, () => {
			toggle_play(index);
		});
		
		$all_audio_players.push({
			audio: $audio,
			play_button: $play_button,
			progress_indicator: $progress_indicator,
		});
	});
	
	// $audio_players.forEach($player => {
	// 	[g.play_e, g.pause_e].forEach(event_name => {
	// 		$player.addEventListener(event_name, e => {
	// 			update_play_status($player, event_name === g.play_e);
	// 		});
	// 	});
	// });
	
	return true;
}


/**
 * Toggle audio playing
 * @param {int} index
 */
function toggle_play(index) {
	const $player = $all_audio_players[index];
	if ($player.audio.paused) {
		$player.audio.play();
		update_play_icon(index, true);
		// update_play_status($player.audio, true);
		progress_interval = setInterval(() => {
			update_progress(index);
		}, 100);
		pause_other_players(index);
	} else {
		$player.audio.pause();
		clearInterval(progress_interval);
		update_play_icon(index, false);
		// update_play_status($player.audio, false);
	}
}


/**
 * Update play status
 * TODO: this borrows heavily from video.js
 * @param {element} $audio
 * @param {boolean} is_playing
 */
function update_play_status($audio, is_playing) {
	const $toggle = document.querySelector(`[aria-controls="${$audio.id}"]`);
	if (!$toggle) return false;
	
	const status_$ = $toggle.getAttribute(play_status_attr);
	const $status = document.querySelector(status_$);
	
	if (is_playing) {
		$status.classList.add(module.is_playing_c);
	} else {
		$status.classList.remove(module.is_playing_c);
	}
}


/**
 * Pause other players
 * @param {int} index
 */
function pause_other_players(index) {
	$all_audio_players.forEach(($player, other_index) => {
		if (index === other_index) return false;
		
		$player.audio.pause();
		update_play_icon(other_index, false);
		// update_play_status($player.audio, false);
	});
}


/**
 * Update progress indicator
 * @param {int} index
 */
function update_progress(index) {
	const $player = $all_audio_players[index];
	const time_current = Math.ceil($player.audio.currentTime);
	const time_total = Math.floor($player.audio.duration);
	const percentage = parseInt(Math.min(time_current / time_total, 1) * 100);
	$player.progress_indicator.style.width = `${percentage}%`;
}


/**
 * Reset player
 * @param {int} index
 */
function reset_player(index) {
	const $player = $all_audio_players[index];
	$player.audio.pause();
	$player.audio.currentTime = 0;
	update_progress(index);
	update_play_icon(index, false);
	clearInterval(progress_interval);
}


/**
 * Update play icon
 * @param {int} index
 * @param {boolean} is_playing
 */
function update_play_icon(index, is_playing) {
	const $player = $all_audio_players[index];
	$player.play_button.setAttribute(is_playing_attr, is_playing ? g.true_s : g.false_s);
}
